import { goURL } from '../../../webmodule-common/other/ui/resource-resolver';

export const resourceFabricationJob = 'fabricationJob';
export async function launchFabricationJob(id: string) {
  goURL(resourceFabricationJob, id);
  return true;
}
